/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::dc25f8b3db4176b6f65213eeb9bb43aa>>
 * @codegenId #tag-group
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen tag-group
 * @codegenParams { "props": {"children": true, "alignment": true } }
 * @codegenDependency ../../../../../../../design-system/tag-group/src/TagGroup/index.tsx <<SignedSource::25b12a649f3bf788a4cb061d0693d72f>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import PlatformTagGroup from '@atlaskit/tag-group';
export var TagGroup = function TagGroup(props) {
  var _ref = props.forgeDoc.props,
    alignment = _ref.alignment;
  return /*#__PURE__*/React.createElement(PlatformTagGroup, {
    children: props.forgeDoc.children.map(function (c) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: c.key
      }, props.render(c));
    }),
    alignment: alignment
  });
};
/**
 * @codegenEnd
 */